import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoMonzo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 149 48"
    {...props}
  >
    <g clipPath="url(#Logo_Monzo_svg__a)">
      <path
        fill="#E34B5F"
        d="M36.639 33.48c-.065.354-.23.683-.474.948l-7.584 7.584a.53.53 0 0 1-.948-.474v-16.59l9.006-9.007z"
      />
      <path
        fill="#E7CE9C"
        d="M30.477 9.779a.474.474 0 1 0-.948 0L18.627 21.155v12.798l9.006-9.006 9.006-9.006z"
      />
      <path
        fill="#1E7889"
        d="M.615 33.48c.065.354.229.683.474.948l7.584 7.584a.53.53 0 1 0 .948-.474v-16.59L.615 15.94z"
      />
      <path
        fill="#97BAA6"
        d="M7.725 9.779a.474.474 0 1 0-.948 0L.615 15.94l9.006 9.006 9.006 9.006V21.155z"
      />
      <path
        fill="currentColor"
        d="M48.016 33.479v-16.59h4.266v1.895a4.74 4.74 0 0 1 4.74-2.37 5.21 5.21 0 0 1 4.267 2.844c1.896-1.896 3.318-2.844 5.214-2.844 3.792 0 6.162 1.896 6.162 6.162V33.48h-4.74v-9.007c0-2.37-.474-3.318-2.37-3.318s-2.844.948-2.844 3.318v9.007h-5.215v-9.007c0-2.37-.474-3.318-1.896-3.318s-2.844.948-2.844 3.318v9.007zm30.337-14.695a9.006 9.006 0 0 1 15.168 6.162 8.53 8.53 0 0 1-2.37 6.162 8.53 8.53 0 0 1-6.636 2.845 8.06 8.06 0 0 1-6.162-2.845 8.53 8.53 0 0 1-2.37-6.162 8.53 8.53 0 0 1 2.37-6.162m6.162 10.429a4.266 4.266 0 0 0 4.266-4.267 4.03 4.03 0 1 0-8.058 0 4.266 4.266 0 0 0 3.792 4.266m12.324 4.266v-16.59h4.74v1.895c.949-1.422 2.371-2.37 4.741-2.37 3.318 0 5.688 2.37 5.688 6.162V33.48h-4.74v-9.007c0-2.37-.474-3.318-2.37-3.318s-3.319.948-3.319 3.318v9.007zm36.025-14.695a9.007 9.007 0 0 1 15.169 6.162 8.53 8.53 0 0 1-2.371 6.162 8.52 8.52 0 0 1-6.162 2.845 8.06 8.06 0 0 1-6.636-2.845 8.54 8.54 0 0 1-2.37-6.162 8.53 8.53 0 0 1 2.37-6.162m6.636 10.429a4.265 4.265 0 0 0 3.792-4.267 4.027 4.027 0 0 0-6.878-2.849 4.03 4.03 0 0 0-1.18 2.85 4.267 4.267 0 0 0 4.266 4.265m-23.7 4.266V30.16l6.636-9.007H115.8v-4.266h12.324v3.792l-6.162 8.532h6.162v4.267z"
      />
    </g>
    <defs>
      <clipPath id="Logo_Monzo_svg__a">
        <path
          fill="#fff"
          d="M.615 0h148v48h-148z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoMonzo;
